import Vue from 'vue';

const state = {

};

const getters = {

};

const actions = {
    initDashboard: ({ commit }, data) => {
        var dashboard = {
            today:{
                graphSummary:{
                    labels:[
                        '08:00',
                        '09:00',
                        '10:00',
                        '11:00',
                        '12:00',
                        '13:00',
                        '14:00',
                        '15:00',
                        '16:00',
                        '17:00',
                        '18:00',
                        '19:00',
                        '20:00',
                        '21:00',
                        '22:00',
                        '23:00',
                        '24:00'
                    ],
                    data:[
                        100.00,
                        150.50,
                        180.80,
                        140.40,
                        200.00,
                        250.50,
                        280.80,
                        100.00,
                        230.30,
                        280.80,
                        410.10,
                        340.40,
                        120.20,
                        20.10,
                        0,
                        0,
                        0
                    ]
                },
                ocupancy:{
                    percent:20,
                    label: '< 80%',
                    labelColor: 'color-6'
                },
                totalSales:{
                    value: '4k',
                    label: '+ 500,00€',
                    labelColor: 'color-3'
                },
                avarageSalePerson:{
                    value: '55,00€'
                },
                cancellations:{
                    value: '02'
                }
            },
            week:{
                graphSummary:{
                    labels:[
                        '08:00',
                        '09:00',
                        '10:00',
                        '11:00',
                        '12:00',
                        '13:00',
                        '14:00',
                        '15:00',
                        '16:00',
                        '17:00',
                        '18:00',
                        '19:00',
                        '20:00',
                        '21:00',
                        '22:00',
                        '23:00',
                        '24:00'
                    ],
                    data:[
                        100,
                        150,
                        180,
                        140,
                        200,
                        250,
                        280,
                        100,
                        230,
                        280,
                        410,
                        340,
                        120,
                        20,
                        0,
                        0,
                        0
                    ]
                },
                ocupancy:{
                    percent:20,
                    label: '< 80%',
                    labelColor: 'color-6'
                },
                totalSales:{
                    value: '4k',
                    label: '+ 500,00€',
                    labelColor: 'color-3'
                },
                avarageSalePerson:{
                    value: '55,00€'
                },
                cancellations:{
                    value: '02'
                }
            },
            month:{
                graphSummary:{
                    labels:[
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                        '10',
                        '11',
                        '12',
                        '13',
                        '14',
                        '15',
                        '16',
                        '17',
                        '18',
                        '19',
                        '20',
                        '21',
                        '22',
                        '23',
                        '24',
                        '25',
                        '26',
                        '27',
                        '28',
                        '29',
                        '30'
                    ],
                    data:[
                        2500,
                        2450,
                        2840,
                        1580,
                        1200,
                        2800,
                        1900,
                        1750,
                        1400,
                        1800,
                        1950,
                        2400,
                        2800,
                        1800,
                        1500,
                        2050,
                        2450,
                        2680,
                        1900,
                        1750,
                        1400,
                        1800,
                        1950,
                        2400,
                        2800,
                        1800,
                        1500,
                        2050,
                        2450,
                        2680
                    ]
                },
                ocupancy:{
                    percent:30,
                    label: '< 70%',
                    labelColor: 'color-6'
                },
                totalSales:{
                    value: '14k',
                    label: '+ 1500,00€',
                    labelColor: 'color-3'
                },
                avarageSalePerson:{
                    value: '75,00€'
                },
                cancellations:{
                    value: '12'
                }
            },
            custom:{
                graphSummary:{
                    labels:[
                        '1',
                        '2',
                        '3',
                        '4',
                        '5',
                        '6',
                        '7',
                        '8',
                        '9',
                        '10',
                        '11',
                        '12',
                        '13',
                        '14',
                        '15',
                        '16',
                        '17',
                        '18',
                        '19',
                        '20',
                        '21',
                        '22',
                        '23',
                        '24',
                        '25',
                        '26',
                        '27',
                        '28',
                        '29',
                        '30'
                    ],
                    data:[
                        2500,
                        2450,
                        2840,
                        1580,
                        1200,
                        2800,
                        1900,
                        1750,
                        1400,
                        1800,
                        1950,
                        2400,
                        2800,
                        1800,
                        1500,
                        2050,
                        2450,
                        2680,
                        1900,
                        1750,
                        1400,
                        1800,
                        1950,
                        2400,
                        2800,
                        1800,
                        1500,
                        2050,
                        2450,
                        2680
                    ]
                },
                ocupancy:{
                    percent:30,
                    label: '< 70%',
                    labelColor: 'color-6'
                },
                totalSales:{
                    value: '14k',
                    label: '+ 1500,00€',
                    labelColor: 'color-3'
                },
                avarageSalePerson:{
                    value: '75,00€'
                },
                cancellations:{
                    value: '12'
                }
            }
        };

        commit('INIT_DASHBOARD', dashboard);
    },
    async downloadSales ({state, commit, dispatch}, data) {
        try {
            console.log('-- Download sales --');
            let dateFrom = moment(data.dateFrom);
            let dateTo = moment(data.dateTo);
            let supplierId = data.supplierId;
            let agentId = data.agentId;
            let productId = data.productId;
            let statusId = data.statusId;
            let page = data.page;
            let pageSize = data.pageSize;
            console.log(data);

            let response = await axios.get('/api/booking/ReportingBookingAgentSales', {
                params: {
                  's.SupplierId': supplierId,
                  's.AgentId': agentId,
                  's.ProductId': productId,
                  's.Status': statusId,
                  's.DateStart': dateFrom.format('YYYY-MM-DD') + ' 00:00:00',
                  's.DateEnd': dateTo.format('YYYY-MM-DD') + ' 23:59:59',
                  'page': page,
                  'pageSize': pageSize
                }
            });

            return response;
        } catch (err) {
          console.error(err);
          return false;
        }
    },

    async downloadAllSales ({state, commit, dispatch}, data) {
        try {
            console.log('-- Download  All sales --');
            let dateFrom = moment(data.dateFrom);
            let dateTo = moment(data.dateTo);
            let supplierId = data.supplierId;
            //debug
            console.log(data);

            let response = await axios.get('/api/booking/ReportingBookingAgentSalesExport', {
                params: {
                    's.SupplierId': supplierId,
                    's.DateStart': dateFrom.format('YYYY-MM-DD') + ' 00:00:00',
                    's.DateEnd': dateTo.format('YYYY-MM-DD') + ' 23:59:59'
                }
            });

            return response;
        } catch (err) {
            console.error(err);
            return false;
        }
    },

    async downloadSalesExport ({state, commit, dispatch}, data) {
        try {
            console.log('-- Download sales export--');
            let dateFrom = moment(data.dateFrom);
            let dateTo = moment(data.dateTo);
            let supplierId = data.supplierId;
            let agentId = data.agentId;
            let productId = data.productId;
            let statusId = data.statusId;

            let response = await axios.get('/api/booking/ReportingBookingAgentSalesDownloadXXX', {
                params: {
                  's.SupplierId': supplierId,
                  's.AgentId': agentId,
                  's.PproductId': productId,
                  's.Status': statusId,
                  's.DateStart': dateFrom.format('YYYY-MM-DD') + ' 00:00:00',
                  's.DateEnd': dateTo.format('YYYY-MM-DD') + ' 23:59:59'
                },
                responseType: 'blob'
            });

            return response;
        } catch (err) {
            console.error(err);
            return false;
        }
    },
};

const mutations = {
    INIT_DASHBOARD: (state, dashboard) => {
        state.dashboard = dashboard;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/reports.js